import defaultState from './state'

const setSearchMessage = (state, showSearchMessage) => {
  Object.assign(state, {
    ...defaultState(),
    showSearchMessage
  })
}

const toggleHandoff = state => {
  Object.assign(state, {
    ...defaultState(),
    showHandoff: !state.showHandoff
  })
}

const toggleChannelControl = state => {
  Object.assign(state, {
    ...defaultState(),
    showChannelControl: !state.showChannelControl
  })
}

const toggleTestResultModal = state => {
  Object.assign(state, {
    ...defaultState(),
    showTestResultModal: !state.showTestResultModal
  })
}

const resetChannelsUI = state => {
  Object.assign(state, { ...defaultState() })
}

const setFilters = (state, showFilters) => {
  Object.assign(state, { showFilters })
}

const setMixedDataError = (state, mixedDataError) => {
  Object.assign(state, { mixedDataError })
}

export default {
  setSearchMessage,
  toggleHandoff,
  toggleChannelControl,
  toggleTestResultModal,
  resetChannelsUI,
  setFilters,
  setMixedDataError
}
